var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"wp-like-sub-menu-item"},[_c('a',{staticClass:"wp-like-sub-menu-item-link",class:_vm.submenuItemData.class,attrs:{"href":_vm.submenuItemData.link},domProps:{"textContent":_vm._s(_vm.submenuItemData.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }